import Reveal from "./Reveal";

/**
 * Shared section header. `tone` switches the palette between the dark and the
 * cream sections so the rhythm stays identical across the page.
 */
const SectionHeading = ({
  index,
  eyebrow,
  title,
  accent,
  intro,
  tone = "dark",
  align = "left",
  className = "",
}) => {
  const isDark = tone === "dark";
  const centered = align === "center";

  return (
    <div
      className={`${centered ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} ${className}`}
    >
      <Reveal>
        <div
          className={`flex items-center gap-4 ${centered ? "justify-center" : ""}`}
        >
          {index && (
            <span
              className={`eyebrow ${isDark ? "text-sage/70" : "text-moss/60"}`}
            >
              {index}
            </span>
          )}
          <span
            className={`h-px w-10 ${isDark ? "bg-sage/40" : "bg-moss/30"}`}
          />
          <span className={`eyebrow ${isDark ? "text-mint" : "text-moss"}`}>
            {eyebrow}
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.08}>
        <h2
          className={`display mt-6 text-[2.6rem] leading-[1.03] sm:text-[3.4rem] md:text-[4.2rem] ${
            isDark ? "text-cream" : "text-ink"
          }`}
        >
          {title}{" "}
          {accent && (
            <em className={`italic ${isDark ? "text-mint" : "text-moss"}`}>
              {accent}
            </em>
          )}
        </h2>
      </Reveal>

      {intro && (
        <Reveal delay={0.16}>
          <p
            className={`mt-6 text-[1.05rem] leading-8 ${
              isDark ? "text-cream/55" : "text-stone"
            } ${centered ? "mx-auto max-w-2xl" : "max-w-2xl"}`}
          >
            {intro}
          </p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionHeading;
